import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.taxbill.list(), config), 'data')
    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'taxbills',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async read({ commit }, { id, config }) {
    const taxbill = get(await this.$axios.get(routes.taxbill.concrete(id), config), 'data')
    commit('AFTER_READ', { namespace: 'taxbills', item: taxbill }, { root: true })
    return taxbill
  },
  async update({ commit }, { id, payload = {}, config = {} }) {
    const data = get(await this.$axios.put(routes.taxbill.concrete(id), payload, config), 'data')
    commit(
      'AFTER_UPDATE',
      {
        namespace: 'taxbills',
        item: data
      },
      { root: true }
    )
    return data
  },
  async approveStatus({ commit }, payload) {
    await this.$axios.post(routes.taxbill.status(), payload)
  },
  async export({ commit }, { payload }) {
    const { data } = await this.$axios.post(routes.taxbill.export(), payload, {
      responseType: 'blob'
    })
    return data
  },
  getTaxBillsTotal({ commit }, query) {
    return this.$axios.get(routes.taxbill.taxBillsTotal(), {
      params: query
    })
  }
}
